import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FileUploadControl, FileUploadValidators, FileUploadModule } from '@iplab/ngx-file-upload';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { KnBrNacTemplateModel } from 'src/app/models/knbr-nac-template.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
// tslint:disable-next-line: max-line-length
import { KnBrDownloadConfirmationDialogComponent } from '../kn-br-download-confirmation-dialog/kn-br-download-confirmation-dialog.component';
import { KnBrUpdateTemplateDialogComponent } from '../kn-br-update-template-dialog/kn-br-update-template-dialog.component';
import { KnBrUploadNewTemplateDialogComponent } from '../kn-br-upload-new-template-dialog/kn-br-upload-new-template-dialog.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-nac-configurable',
    templateUrl: './kn-br-nac-configurable.component.html',
    styleUrls: ['./kn-br-nac-configurable.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, FileUploadModule, AsyncPipe, TranslatePipe]
})
export class KnBrNacConfigurableComponent implements OnInit {
  public fileUploadControl = new FileUploadControl()
    .setListVisibility(false)
    .setValidators([FileUploadValidators.filesLimit(1)]);
  nacTemplateList$: Observable<KnBrNacTemplateModel[]> = this.knBrCommonService.loadNacTemplateList$();
  selectedTemplateData: KnBrNacTemplateModel;
  selectedTemplateCode: string;
  documentTypes = '.csv';
  downloadTypeProductAttributes: false;
  downloadTypeImages: false;
  downloadOtherProductAssets: false;
  downloadAllTheProducts: false;
  uploadNewTemplateModalRef: any;
  updateTemplateModalRef: any;
  downloadConfirmationModalRef: any;

  nacConfigurbaleForm: FormGroup = this.fb.group({
    template: new FormControl({ value: '', disabled: false }),
  });

  constructor(
    protected fb: FormBuilder,
    protected modalService: NgbModal,
    protected knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.knBrCommonService.getNacTemplateList();
  }

  openUploadNewTemplateDialog() {
    this.uploadNewTemplateModalRef = this.modalService.open(KnBrUploadNewTemplateDialogComponent);
  }

  openUpdateTemplateDialog() {
    // Get the selected template data and pass it
    let modalInstance: any;
    this.updateTemplateModalRef = this.modalService.open(KnBrUpdateTemplateDialogComponent);
    modalInstance = this.updateTemplateModalRef.componentInstance;
    modalInstance.templateData = this.selectedTemplateData;
    // removing the selected template data once update is done.
    this.updateTemplateModalRef.result.then((res) => {
      this.selectedTemplateData = null;
      this.selectedTemplateCode = null;
    });
  }

  downloadProductAttributes() {
    this.knBrCommonService.downloadNacProductAttributes();
  }

  deleteTemplate() {
    this.knBrCommonService.deleteNacTemplate(this.selectedTemplateData.templateName);
  }

  onTemplateSelection(templateData) {
    // set the selected template
    this.selectedTemplateData = templateData;
    this.selectedTemplateCode = templateData.code;
    this.downloadTypeProductAttributes = false;
    this.downloadTypeImages = false;
    this.downloadOtherProductAssets = false;
    this.downloadAllTheProducts = false;
    this.fileUploadControl.clear();
  }

  openDownloadConfirmationDialog() {
    const formData: FormData = new FormData();

    // Condition to send the file
    if (!this.downloadAllTheProducts) {
      formData.append('attachment', this.fileUploadControl.value[0]);
    }

    this.knBrCommonService
      .importOrDownloadNacTemplate(
        this.selectedTemplateData.templateName,
        this.downloadTypeProductAttributes,
        this.downloadTypeImages,
        this.downloadOtherProductAssets,
        formData
      )
      .subscribe(
        (response: any) => {
          // open on success.
          this.downloadConfirmationModalRef = this.modalService.open(KnBrDownloadConfirmationDialogComponent);
        },
        (errorRes) => {
          // Write code to show the message from backend.
          const errors = (errorRes?.error?.errors || errorRes?.details || []) as Array<any>;
          if (errors.length > 0) {
            errors.forEach((error) => {
              const type = error.type.toLowerCase();
              if (type.indexOf('warning') !== -1) {
                this.globalMessageService.add({ raw: error.message }, GlobalMessageType.MSG_TYPE_WARNING);
              } else if (type.indexOf('error') !== -1) {
                this.globalMessageService.add({ raw: error.message }, GlobalMessageType.MSG_TYPE_ERROR);
              }
            });
          } else {
            if (this.downloadAllTheProducts) {
              this.globalMessageService.add({ key: 'nacMessages.importFailureMsg' }, GlobalMessageType.MSG_TYPE_ERROR);
            } else {
              this.globalMessageService.add(
                { key: 'nacMessages.downloadFailureMsg' },
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        }
      );
  }
}
